<template>
  <SearchResultView :seo-type="_usageCategoryId"></SearchResultView>
</template>
<script setup>

import SearchResultView from "@/components/SearchResult/SearchResultView.vue";

definePageMeta({
  title: '搜尋結果'
})
import {onMounted, provide} from "vue";
import {useRouteQuery} from "@vueuse/router";

import {useQueryFormatter} from "@/composables/useQueryFormatter";
import {useSearchWithStore} from "@/composables/useSearchWithStore";
import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {useCityStore} from "@/stores/city.js";
import {useCategoryStore} from "@/stores/category.js";

const route = useRoute();
const router = useRouter()

const {handleSearchWithStore} = useSearchWithStore()
const {setSearchQueryRouteToStore} = useQueryFormatter()
const searchQueryStore = useSearchQueryStore()
const cityStore = useCityStore()
const categoryStore = useCategoryStore()
const _usageCategoryId = useRouteQuery('_usageCategoryId', []);

const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID

// 搜尋條件完全空白(全新進站、非由首頁/連結帶條件)才視為 pristine
function isStorePristine() {
  const f = searchQueryStore.filter_options
  return !f.city_ids?.length
    && !Object.values(f.category_ids || {}).some((arr) => arr?.length)
    && !Object.keys(f.people_cap_range || {}).length
    && !Object.keys(f.price_range || {}).length
    && !f.equipment_ids?.length
    && !f.service_ids?.length
    && !f.keyword
}

// 直接進搜尋頁且無任何條件時的預設篩選:縣市=台北市、用途=教室｜會議。
function applyDefaultFilters() {
  const taipei = cityStore.getCityList.find((c) => c.city_name === '台北市')
  if (taipei) {
    searchQueryStore.setSelectedCityID([taipei.city_id])
  }
  const meetingUsage = categoryStore.getUsageCategories.find(
    (u) => u.name?.includes('教室') && u.name?.includes('會議'),
  )
  if (meetingUsage) {
    searchQueryStore.setSelectedCategoryObject({ [usageCategoryId]: [meetingUsage.id] })
  }
}


const layoutProps = {
  footer: false
};
provide('searchBasicLayoutProps', layoutProps);

const seoMeta = {
  title: '場地租借到空間便利店，快速找到理想空間！',
  description: '場地租借平台推薦選空間便利店！我們提供多樣化的場地租借空間、多種時段方案，加上預約流程簡單快速，可讓您輕鬆找到理想場地！想了解更多推薦場地和租借秘訣？快往下閱讀我們的場地租借筆記吧！',
  keywords: '場地租借、會議室、攝影棚、廚房租借、活動空間、餐廳包廂、聚會場地，都可線上預約',
  ogTitle: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogSiteName: '空間便利店',
  ogDescription: '空間便利店是一個線上的場地租借平台。我們提供線上預約，省去聯絡，方便又順利。活動空間、會議室，攝影棚、餐廳包廂、聚會場地都可預約。',
  ogImage: 'https://pic.onestep.place/images/onestep-og.png',
  ogImageAlt: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogUrl: 'https://www.onestep.place',
  ogType: 'website',
};

useSeoMeta(seoMeta);


onMounted(() => {

  if (route.query.sid) {
    router.push({path: `/space/${route.query.sid}`})
  }

  // 檢查是否有有效的查詢參數
  const hasValidQuery = (query) => query && Object.keys(query).length > 0;

  // 處理路由查詢參數的主邏輯
  const processRouteQuery = (query) => {
    setSearchQueryRouteToStore(query);
    handleSearchWithStore();
  };

  // 主執行流程
  if (hasValidQuery(route.query)) {
    processRouteQuery(route.query);
  } else {
    // 無查詢參數的直接進站:條件全空才套用預設(台北市 + 教室｜會議),再搜尋
    if (isStorePristine()) {
      applyDefaultFilters();
    }
    handleSearchWithStore();
  }

})
</script>

<style scoped
       lang="scss">

</style>
